import { DEFAULT_JOB_STATUS_FILTER } from '@shared/models/job-statuses';
import { retrieve } from '@shared/utils';

import { JobsPageFilterActionsUnion, JobsPageFilterActionTypes } from './filter.actions';

export enum JobsPageFilterType {
  ALL = 'ALL',
  MY = 'MY'
}

export interface JobsPageFilter {
  jobAssignedTo?: JobsPageFilterType;
  status?: string;
  offset?: number;
}

export const initialState: JobsPageFilter = {
  jobAssignedTo: JobsPageFilterType.MY,
  status: DEFAULT_JOB_STATUS_FILTER,
  offset: 0
};

export const homePageFilterKey = 'homePageFilter';

export function jobsPageFilterReducer(
  state = retrieve(homePageFilterKey, initialState),
  action: JobsPageFilterActionsUnion
): JobsPageFilter {
  switch (action.type) {
    case JobsPageFilterActionTypes.Set:
      return { ...state, ...action.payload };

    case JobsPageFilterActionTypes.SetAll:
      return {
        jobAssignedTo: JobsPageFilterType.ALL,
        status: DEFAULT_JOB_STATUS_FILTER,
        offset: 0
      };

    case JobsPageFilterActionTypes.SetMy:
      return {
        jobAssignedTo: JobsPageFilterType.MY,
        status: DEFAULT_JOB_STATUS_FILTER,
        offset: 0
      };

    default:
      return state;
  }
}
